import * as React from 'react';

import { UILocation } from '@1js/acui-common';
import { AppLabelProps } from '@1js/acui-label';

import { RibbonLabel } from '../Controls';

export function getDefaultLabelRenderer() {
  return (props: AppLabelProps) => <RibbonLabel {...props} location={props.location || UILocation.Ribbon} />;
}
